import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import resolveTerms from '../forms/termsResolver';
import { TermsBlock } from '../../pages/SelectEzi_Landing_Page/Policies/General_Terms/components/TermsBlockRenderer';

/**
 * Reusable modal that displays the appropriate Terms & Conditions for a form.
 * Uses the existing `resolveTerms` utility to match based on form title and pathname.
 */
const TermsModal = ({ show, onClose, formTitle }) => {
  const location = useLocation();
  const terms = resolveTerms({ title: formTitle, pathname: location.pathname });

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      centered
      backdrop={true}
      keyboard={true}
      dialogClassName="terms-modal-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title>{terms?.shortTitle || terms?.tabTitle || 'Terms & Conditions'}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1rem 1.5rem' }}>
        {terms ? (
          <>
            {terms.docTitle && (
              <div className="mb-3 text-center">
                {Array.isArray(terms.docTitle)
                  ? terms.docTitle.map((line, i) => (
                      <div key={i} style={{ fontWeight: i === 0 ? 700 : 600, fontSize: i === 0 ? '1.1rem' : '1rem' }}>
                        {line}
                      </div>
                    ))
                  : <div style={{ fontWeight: 700 }}>{terms.docTitle}</div>
                }
                {terms.lastUpdated && (
                  <small className="text-muted">Last Updated: {terms.lastUpdated}</small>
                )}
              </div>
            )}
            {Array.isArray(terms.blocks) && terms.blocks.map((block, i) => (
              <TermsBlock key={i} block={block} />
            ))}
            {!terms.blocks && terms.summary && (
              <p>{terms.summary}</p>
            )}
          </>
        ) : (
          <p className="text-muted text-center py-4">No terms available for this form</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" className='pt-2 pb-2 ps-4 pe-4' onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsModal;
